import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Table, message, Modal, Checkbox } from 'antd';
import { emptyFun } from '@untils/common';
import { apiDomain } from '@untils/config';
import { pageConfig, pagination, res, getColumnsWidth } from './config';
import { CheckCircleOutlined, SettingOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import { checkExcelExport } from '@service';
import merge from './merge';
import AuthButton from '../auth-button';
import './index.less';
const CheckboxGroup = Checkbox.Group;

const PurposeTable = props => {
  const {
    selectType = 'checkbox',
    getSelectRowKey = emptyFun,
    getSelectRow,
    selectedRowKeys: propsSelectedRowKeys = [],
    searchHook,
    searchObj = {},
    param = {},
    request = emptyFun,
    columns: propsColumns = {},
    rowKey,
    rowClassName,
    functionMap,
    tab,
    size = 'small',
    // bordered = true,
    selectMaxLength = 10000,
    tableName = '',
    needExport = true,
    shouldExport = () => true, // 导出前判断是否可以导出
    needSetting = true,
    operateWidth,
    showPagination = true,
    pageSize = 10,
    pageSizeOptions = ['10', '20', '50', '100'],
    refreshHook,
    expandable = {}, //子菜单展开
    afterRequest = emptyFun,
  } = props;

  // 定义State
  const [selectedRowKeys, setSelectedRowKeys] = useState(propsSelectedRowKeys);
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [pageInfo, setPageInfo] = useState({ ...pageConfig, pageSize, page_size: pageSize });
  const [total, setTotal] = useState(0);
  const [columns, setColumns] = useState([]);
  const [tableWidth, setTableWidth] = useState(0);
  const [isInit, setIsInit] = useState(true);
  const [url, setUrl] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [visible, setVisible] = useState(false);
  const [accurate, setAccurate] = useState(true);
  const [checkboxCol, setCheckboxCol] = useState([]);
  const [checkboxVal, setCheckboxVal] = useState([]);
  const [checkColumns, setCheckColumns] = useState([]);

  // useEffect(() => {
  //   setSelectedRowKeys(propsSelectedRowKeys);
  // }, [propsSelectedRowKeys]);

  // 获取数据
  const getDataSource = async () => {
    setSelectedRowKeys([]);
    setLoading(true);
    const { data } = (await request({ ...param, ...pageInfo, ...searchObj })) || {
      ...res,
    };
    const {
      list,
      field_label: fieldLabel = {},
      field_sort: fieldSort = [],
      field_map: fieldMap = {},
      count,
      is_accurate = true,
      shouldColumnsUpdate = false,
    } = data || {};

    // 传到回调里面使用请求回来的数据
    afterRequest(data || {});

    if (tableWidth === 0 || shouldColumnsUpdate) {
      const { tableWidth, columns } = merge(
        propsColumns,
        fieldLabel,
        fieldSort,
        fieldMap,
        functionMap,
        tab,
        operateWidth
      );

      setColumns(columns);
      setTableWidth(tableWidth);
      const valStr = localStorage.getItem(url) || '';
      const vals = valStr.split(',');

      if (valStr) {
        const newColumns = [];

        columns.map(item => {
          if (vals.indexOf(item.dataIndex) > -1 || item.title === '操作') {
            newColumns.push(item);
          }
        });
        setCheckColumns(newColumns);
        setTableWidth(getColumnsWidth(newColumns));
      }
      setCheckboxVal(vals);
    }
    setDataSource(list);
    setTotal(count);
    setAccurate(is_accurate);
    setLoading(false);
  };

  // 获取数据Effect
  useEffect(() => {
    isInit ? setIsInit(false) : getDataSource();
  }, [pageInfo, refreshHook]);

  useEffect(() => {
    searchHook !== -1 &&
      setPageInfo({
        ...pageInfo,
        page_index: 1,
        current: 1,
      });
  }, [searchHook]);

  // 分页按钮切换触发
  const handleChange = ({ current, pageSize }, filters, { field, order }) => {
    setPageInfo({
      current,
      pageSize,
      page_index: current,
      page_size: pageSize,
      order_sort: (order === 'descend' && 'desc') || (order === 'ascend' && 'asc') || '',
      order_field: (order && field) || '',
      ...filters,
    });
  };

  const fGetUrl = options => {
    let url = '?';

    //get请求将parms拼接到url上
    for (let keys in options) {
      if (Object.prototype.hasOwnProperty.call(options, keys)) {
        options[keys] && (url = url + '&' + keys + '=' + options[keys]);
      }
    }

    return url;
  };

  const returnObj = str => {
    // url:/goods/goods-basic/index,params:params,
    const arr = str.split(',');
    const result = {};

    arr.map(item => {
      const subArr = item.split(':');
      const key = subArr[0];

      if (key) {
        result[key] = subArr[1];
      }
    });
    return result;
  };

  useEffect(() => {
    const requestFunStr = request
      .toLocaleString()
      .replace(/[\r\n]/g, '')
      .replace(/\ +/g, '');

    if (requestFunStr !== 'function(){}') {
      const urlStr = requestFunStr
        .match(/\)\(\{(\S*)\}\)/)[1]
        .replace(/\"/g, '')
        .replace(/\'/g, '');
      const { url, authCode } = returnObj(urlStr);

      setUrl(url);
      setAuthCode(authCode);
    }
  }, []);

  const download = async () => {
    if (!shouldExport()) {
      return;
    }

    const mode = process.env.NODE_ENV;
    const params = { ...param, ...searchObj, task_name: tableName, count: total, ...pageInfo };
    const paramStr = fGetUrl(params);
    const downUrl = apiDomain[mode] + url + paramStr;
    const referer = window.location.pathname;

    const { flag, msg } = await checkExcelExport({
      referer,
      url: downUrl,
      check: '1',
    });

    if (flag === 200) {
      window.open(
        apiDomain[mode] + '/common/data-export/data-export' + '?referer=' + referer + '&url=' + downUrl,
        '_self'
      );
    } else if (flag === 410) {
      window.parent.postMessage({ redirect_url: window.location.href }, '*');
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    if (!checkboxCol.length) {
      const checkboxCol = [];
      const vals = [];

      columns.map(({ title, dataIndex }) => {
        if (title !== '操作') {
          vals.push(dataIndex);
          checkboxCol.push({
            label: title,
            value: dataIndex || '',
          });
        }
      });

      const cacheVals = localStorage.getItem(url) || '';

      setCheckboxCol(checkboxCol);
      setCheckboxVal(cacheVals ? cacheVals.split(',') : vals);
    }
  }, [visible]);

  const setting = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onChange = val => {
    setCheckboxVal(val);
    const newColumns = [];

    columns.map(item => {
      if (val.indexOf(item.dataIndex) > -1 || item.title === '操作') {
        newColumns.push(item);
      }
    });
    setCheckColumns(newColumns);
    setTableWidth(getColumnsWidth(newColumns));
    localStorage.setItem(url, val);
  };

  return (
    <Fragment>
      {!accurate && total > 0 && <h3 className="mb-12 mt-12 table-tips">未搜索到精确信息，模糊查找结果如下...</h3>}
      {selectType === 'checkbox' && (
        <div className="has-select-box">
          <CheckCircleOutlined className="select-icon" />
          已选择<span className="select-num">{selectedRowKeys.length}</span>项
          {selectedRowKeys.length > 0 && (
            <a
              className="clear-select"
              onClick={() => {
                setSelectedRowKeys([]);
                getSelectRowKey([]);
              }}
            >
              清空
            </a>
          )}
        </div>
      )}
      <div className="table-cell">
        {needSetting && (
          <AuthButton shape="circle" className="setting" onClick={setting}>
            <SettingOutlined />
          </AuthButton>
        )}

        {total > 0 && needExport && (
          <AuthButton
            shape="circle"
            className="download"
            authCode={authCode ? authCode + '-EXPORT' : ''}
            onClick={download}
          >
            <CloudDownloadOutlined />
          </AuthButton>
        )}

        <Table
          // bordered={bordered}
          size={size}
          columns={checkColumns.length ? checkColumns : columns}
          rowKey={rowKey}
          rowClassName={rowClassName}
          dataSource={dataSource}
          onChange={handleChange}
          rowSelection={
            selectType !== 'none' && {
              type: selectType,
              selectedRowKeys: selectedRowKeys,
              onChange: selectedRowKeys => {
                selectMaxLength;
                if (selectMaxLength < selectedRowKeys.length) {
                  message.error(`最大可以选择${selectMaxLength}!`);
                  return;
                }
                getSelectRowKey(selectedRowKeys);
                getSelectRow && getSelectRow(dataSource.filter(item => selectedRowKeys.indexOf(item[rowKey]) > -1));
                setSelectedRowKeys(selectedRowKeys);
              },
              getCheckboxProps: record => ({
                disabled: record.disabled,
              }),
            }
          }
          loading={loading}
          pagination={
            showPagination && {
              ...pageInfo,
              ...pagination,
              pageSizeOptions,
              total,
            }
          }
          // scroll={{ x: tableWidth }}
          expandable={expandable}
          showSorterTooltip={false}
        />
        {total > 0 && showPagination && (
          <div className="total">
            共<span>{total}</span>条数据
          </div>
        )}
      </div>
      <Modal title="设置显示列" visible={visible} onCancel={handleCancel} footer={null}>
        <CheckboxGroup options={checkboxCol} value={checkboxVal} onChange={onChange} />
      </Modal>
    </Fragment>
  );
};

PurposeTable.propTypes = {
  selectType: PropTypes.oneOf(['checkbox', 'radio', 'none']),
  getSelectRowKey: PropTypes.func,
  selectedRowKeys: PropTypes.array,
  searchHook: PropTypes.node,
  searchObj: PropTypes.object,
  param: PropTypes.object,
  request: PropTypes.func,
  columns: PropTypes.object,
  rowKey: PropTypes.string,
  functionMap: PropTypes.object,
  tab: PropTypes.string,
  expandable: PropTypes.object,
};

PurposeTable.defaultProps = {
  selectedRowKeys: [],
  columns: {},
};

export default PurposeTable;
